<template>
  <div class="l-header-audit">
    <div class="l-header-audit__inner">
      <div class="l-header-audit__data">
        <div class="audit-data">
          <div class="audit-data__info">
            <div class="name">
              <span class="audit-data-name js-audit-data-name">{{ this.diagTitle }}</span>
              <a @click="changeDiagTitle(true)" class="link-arrow" style="margin-left: 2rem;">監査名の変更</a>
            </div>
            <div class="corse">{{ this.diagCourseName }}</div>
            <div class="progress">
              <p><strong>{{ progress }}％</strong> {{ score }}/{{ totalScore }}</p>
              <div class="progress_bar"><span :style="'width: ' + progress + '%'"></span></div>
            </div>
            <div class="label-update"><span v-show="diagRevisionFlg">UPDATE</span></div>
          </div>
        </div>
      </div>
      <div class="btn-create-new_wh"><a @click="goNewDiag()">監査の新規作成</a></div>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";

export default {
  components: {
  },
  data() {
    return {
      execChangeDiagTitle: false
    }
  },
  props: {
    score: {},
    totalScore: {},
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.getters['diag/getTitle'];
    },
    diagCourseName() {
      return this.$store.getters['diag/getDiagCourseName'];
    },
    progress() {
      return Math.floor((this.score / this.totalScore) * 100);
    },
    diagRevisionFlg() {
      return this.$store.getters['diag/getDiagRevisionFlg'];
    }
  },
  methods: {
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
      this.$emit("emit-diag-title-change", this.execChangeDiagTitle);
    },
    async exportResult() {
      this.$toast.info('ダウンロードを開始しました。');
      await saveAs('/ld/api/diag/export?id=' + this.diagResultId);
    },
    goNewDiag() {
      this.$router.push({ name: 'diag-course-select' });
    },
  }
}

</script>

